import React from 'react';
import GroomingToolConfigurator from './components/GroomingToolConfigurator';

function App() {
  return (
    <div>
      <GroomingToolConfigurator />
    </div>
  );
}

export default App;